module.exports = __webpack_public_path__ + "img/icon_map_1_on_001.63c397c3.png";